import React from 'react';
import { Outlet } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import { connect } from 'react-redux';
import MenuDrawer from './drawer';
import ToastHandler from 'components/Toast-Handler/toast-handler';
import { getRemainingPaymentDays } from 'utils/formatter.js';
import SidebarNav from 'global/SidebarNav';
import { tokens } from 'theme/tokens';

// const PAYMENT_LINK = <a href='/app/profile'>Click here</a>;
const PAYMENT_MESSAGE = 'days left to make next payment.';

const RootContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  height: '100vh',
  overflow: 'hidden',
  width: '100%'
}));

const Wrapper = styled('div')({
  flexShrink: 1,
});
  
const ContentContainer = styled('div')({
  flexGrow: 12,
  background: '#FEFEFE',
});

const Content = styled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto',
  margin: '0px 10px',
  padding: '8px'
});

const DashboardLayout = ({ users, tenant }) => {
  //const classes = useStyles();    
  let toastElement = null;
  const toast = {};
  let loggedUserInitial = null;
  
  if(users) {
    const loggedUser = users.filter(u => u.email === localStorage.ACTIVE_USER_EMAIL)[0];
    if(loggedUser) {
      loggedUserInitial = loggedUser.firstName[0]+loggedUser.lastName[0];
    }
    if (tenant && tenant.nextPaymentDate) {
      const paymentDays = getRemainingPaymentDays(tenant.nextPaymentDate);
      if (paymentDays === 0 || paymentDays < 0) {
        toast.message = `Payment Overdue. Please go to My Profile to make payment.`;
        toast.type = 'ERROR';
      } else if (paymentDays <= 3) {
        toast.message = `${paymentDays} ${PAYMENT_MESSAGE}. Please go to My Profile to make payment.`;
        toast.type = 'WARNING';
      }
      toastElement = toast && <ToastHandler component='DashboardLayout'
        toast={toast}
        type={toast.type} />;
    }
  }
  return (
    <RootContainer>
      <Wrapper>
        <SidebarNav />
      </Wrapper>
      <ContentContainer>
        <Content>
          {toastElement}
          <Outlet />
        </Content>
      </ContentContainer>
    </RootContainer>
  );
};

function mapStateToProps(state) {
  const { loggedUser } = state.loginReducer;
  const { tenant, users, } = state.tenantReducer;
  return {
    loggedUser,
    tenant,
    users,
  };
}


export default connect(mapStateToProps,null)(DashboardLayout);